var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconClose(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.845,
    height: 13.845,
    viewBox: "0 0 13.845 13.845",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Close_Icon",
    d: "M223.922-734.6l-5.159,5.159a1,1,0,0,1-.737.29,1,1,0,0,1-.737-.29,1,1,0,0,1-.29-.737,1,1,0,0,1,.29-.737l5.159-5.159-5.159-5.159a1,1,0,0,1-.29-.737,1,1,0,0,1,.29-.737,1,1,0,0,1,.737-.289,1,1,0,0,1,.737.289l5.159,5.159,5.159-5.159a1,1,0,0,1,.737-.289,1,1,0,0,1,.737.289,1,1,0,0,1,.29.737,1,1,0,0,1-.29.737l-5.159,5.159,5.159,5.159a1,1,0,0,1,.29.737,1,1,0,0,1-.29.737,1,1,0,0,1-.737.29,1,1,0,0,1-.737-.29Z",
    transform: "translate(-217 743)",
    fill: "#889398"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconClose);
export default __webpack_public_path__ + "static/media/icon_close.3ba7486ee9ea7c8bfa10dd23cdcec62b.svg";
export { ForwardRef as ReactComponent };